import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// components
import LoginComp from 'components/login/LoginComp';
import Head from 'components/metatags_helmet/metatags';
import TitleWithLine from 'components/titleWithLine';

const LoginPage = () => {
  const { t } = useTranslation(['login'])
  const title = t('iniciarSesion');

  return (
    <div className="container-fluid mainDiv container">
      <Head title={title} noIndex={true} />
      <Row className="mainRow infoRow">
        <Col lg={12} className="mt-4 d-flex flex-column">
          <div className="container">
            <TitleWithLine text={t('bienvenido')} />
          </div>
          <div className="row justify-content-center mx-2">
            <div className="col-md-12">
              <p className="mb-4 title-cuenta">{t('tienesCuenta')}</p>
            </div>
            <LoginComp />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LoginPage;
